// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"317":"7242ed92","373":"b11121c5","621":"36b6909c","645":"ca9da931"}[chunkId] + ".js";
};